define('bootstrapper.tasks',['require','bootstrapping/browserSupportTask','bootstrapping/viewLocatorTask','bootstrapping/knockoutBindingTask','bootstrapping/binderTask'],function (require) {
    return {
        getCollection: function () {
            return [
                require('bootstrapping/browserSupportTask'),
                require('bootstrapping/viewLocatorTask'),
                require('bootstrapping/knockoutBindingTask'),
                require('bootstrapping/binderTask')
            ];
        }
    };
});
